import {state as lifecycle} from 'fragments/lifecycle';
import {emptyPagination} from 'constants/pagination';

export default {
	...lifecycle,
	initialized: false,
	logsQuery: {_page: 1, logModel: 'piimega'},
	logs: [],
	logsLoading: true,
	logsPagination: emptyPagination,
	fetchingMore: false,
	organizations: [],
	teams: [],
};
